import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static classes = ["toggle"]
  static targets = ["toggle"]

  on() {
    if (this.hasToggleTarget) {
      this.toggleTargets.forEach((element) => element.classList.add(this.toggleClass))
    } else {
      this.element.classList.add(this.toggleClass)
    }
  }

  off() {
    if (this.hasToggleTarget) {
      this.toggleTargets.forEach((element) => element.classList.remove(this.toggleClass))
    } else {
      this.element.classList.remove(this.toggleClass)
    }
  }

  toggle() {
    if (this.hasToggleTarget) {
      this.toggleTargets.forEach((element) => element.classList.toggle(this.toggleClass))
    } else {
      this.element.classList.toggle(this.toggleClass)
    }
  }
}
